module.exports = __webpack_public_path__ + "img/gzale_exzoticfarms.8993a91.png";